import React, { useEffect, useState } from "react";
import tick from "../../Assets/svg/green-bg-tick.svg";
import "./income.scss";
import IncomeTop from "./IncomeTop";
import EarningMemberInfo from "./EarningMemberInfo";
import { useDispatch, useSelector } from "react-redux";
import {
  addIncomeCount,
  addIncomeInfo,
  addIncomeTotal,
  setDateList,
  setEarning,
} from "./redux/actions";
import { modifyPage } from "../ApplicationForm/redux/actions";
import ModalComponent from "../modules/Modal";
import Button from "../modules/Button";

function IncomeDetails(props) {
  const [list, setlist] = useState([]);
  const [familyData, setFamilyData] = useState({});
  const [count, setCount] = useState({ total: 0, remaining: 0 });
  const [err, setErr] = useState(false);
  const incomeInfo = useSelector((state) => state.income.incomeInfo);
  const dateList = useSelector((state) => state.income.dateList);
  const [isModal, showModal] = useState({ show: false, msg: "", type: "" });

  const dispatch = useDispatch();
  const checkCount = () => {
    let newCount = 0;
    for (let i in familyData) {
      for (let j in familyData[i]) {
        if (!familyData[i][j]) {
          newCount += 1;
        }
      }
    }
    setCount({ ...count, remaining: newCount });
  };
  const addData = (role, type, data) => {
    let newData = incomeInfo?.membersList;
    // role = setRole(role);
    if (role === "My") {
      role = "Myself";
    }
    if (type === "dob" && data) {
      dispatch(setDateList([role, data]));
    }
    if (newData?.filter((a) => a?.relationShipType === role)[0]) {
      if (type === "dob") {
        if (data !== "") {
          newData.filter((a) => a?.relationShipType === role)[0][type] = data;
        }
      }else{
        newData.filter((a) => a?.relationShipType === role)[0][type] = data;

      }
    }

    dispatch(addIncomeInfo(newData));
    dispatch(modifyPage("Yes"));

    // newData[role][type] = data;
    // setFamilyData({ ...newData });
    checkCount();
  };

  const setRole = (role) => {
    if (role !== "") {
      if (role.includes("My ")) {
        role = role.replace("My ", "");
      }
    }
    return role;
  };

  useEffect(() => {
    let total = Math.abs((count.remaining / count.total) * 100 - 100);
    props.onChange(total);
    // console.log("total", total);
  }, [count]);

  useEffect(() => {
    if (list?.length > 0) {
      let newData = [];
      let newList = [];
      if (list) {
        newList = [...list];
      }
      let newList1 = [];

      incomeInfo.membersList.forEach((element) => {
        newList1 = [...newList1, setRole(element?.relationShipType)];
      });
      // setlist([...newList]);
      for (let i in newList) {
        let role = "";

        if (newList[i] !== "No-one") {
          setCount({ ...count, total: newList?.length * 7 });

          role = newList[i];

          role = setRole(role);

          let existingData = incomeInfo?.membersList?.filter(
            (a) => a?.relationShipType === role
          )[0];
          console.log("dob set here", existingData);
          newData = [
            ...newData,
            {
              relationShipType: role,
              firstName: existingData?.firstName || "",
              occupation: existingData?.occupation || "",
              income: existingData?.income || "",
              mobile: existingData?.mobile || "",
              pan: existingData?.pan || "",
              // doc: existingData?.doc || "",
              dob: existingData?.dob || "",
            },
          ];
        } else {
          newData = [
            {
              relationShipType: "No-one",
              firstName: "",
              occupation: "",
              income: "",
              mobile: "",
              pan: "",
              // doc: existingData?.doc || "",
              dob: "",
            },
          ];
          dispatch(setEarning(false));
          setCount({ ...count, total: 1 });
        }
      }
      // console.log("in add", incomeInfo.membersList, newData);

      dispatch(addIncomeInfo(newData));
      dispatch(modifyPage("Yes"));

      setFamilyData({ ...newData });
    }
  }, [list]);

  useEffect(() => {
    props?.setErr(err);
  }, [err]);

  useEffect(() => {
    let total = 0;
    let count = 0;
    if (incomeInfo.membersList[0]?.relationShipType === "No-one") {
      total += 1;
      if (incomeInfo.membersList[0]?.document) {
        count += 1;
      }
    } else {
      for (let i in incomeInfo.membersList) {
        total += 7;
        let items = [
          "dob",
          "firstName",
          "income",
          "mobile",
          "occupation",
          "pan",
          "doc",
        ];
        for (let j in items) {
          if (!incomeInfo.membersList[i][items[j]]) {
            count += 1;
          }
        }
        // if()

        // }
      }
    }
    dispatch(addIncomeTotal(total));
    dispatch(addIncomeCount(count));

    console.log("total", total, count);
  }, [incomeInfo]);
  return (
    <div className="form-section income-form">
      <IncomeTop
        onChange={(e) => setlist(e)}
        list={list}
        showModal={(e) => showModal({ ...isModal, show: true, msg: e })}
        list2={incomeInfo?.membersList}
      />
      {
        // !incomeInfo.membersList.includes("No-one") &&
        incomeInfo?.membersList?.map((item, index) => {
          if (item?.relationShipType !== "No-one") {
            return (
              <EarningMemberInfo
                setErr={(e) => setErr(e)}
                familyData={[]}
                showModal={(e) => showModal({ ...isModal, show: true, msg: e })}
                addData={addData}
                item={item}
                key={index}
              />
            );
          }
        })
      }
      {isModal.show && (
        <ModalComponent
          className={"disburse-model"}
          show={isModal.show}
          handleClose={() => showModal({ ...isModal, show: false })}
          // title={ModalData.title}
          // content={ModalData.desc}
          noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <div>
              {isModal.msg ===
                "Your Document has been uploaded successfully!" && (
                <img src={tick} alt="tick" />
              )}
            </div>
            <div className="md-title">
              {/* Document uploaded successfully! */}
              {isModal.msg}
            </div>
            {/* <div className="md-desc">
                You will receive email notifications on your scholarship
                payment(s), once disbursed.
              </div> */}
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => showModal(false)}
                type={"contained "}
                value={"OK"}
              />
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
}

export default IncomeDetails;
